/* MysteryKitz frame service (sections/mk-frame-service.liquid).
   - Tier, frame colour and passe-partout swap the photo-real mockup (files mkf-<tier>-<color>-<mat>.jpg, map in
     [data-mkf-shots]); the name plate is live text on top, shrunk to fit.
   - Classic has no colour choice (black) and no name plate: those controls lock / hide.
   - Order: /cart/add.js as JSON with line-item properties, then to the cart. Only rendered while variants are live.
   - ?lijst=classic|premium|legend preselects a tier; links with data-mkf-go scroll smoothly.
   - Sticky bar: visible after the hero, hidden while the configurator or the closing box is on screen. */
(() => {
  // Engraved plate: shrink long texts so they stay on the plate
  const fitPlate = (span) => {
    const box = span && span.parentElement;
    if (!box || !box.clientWidth) return;
    let size = 1.45;
    box.style.fontSize = `${size}cqw`;
    while (span.scrollWidth > span.clientWidth + 1 && size > 0.7) {
      size -= 0.05;
      box.style.fontSize = `${size.toFixed(2)}cqw`;
    }
  };
  document.querySelectorAll('.mkf-shot [data-mkf-plate]').forEach(fitPlate);

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  document.querySelectorAll('[data-mkf]').forEach((root) => {
    if (root.dataset.mkfReady) return;
    root.dataset.mkfReady = 'true';

    let data = {};
    try {
      data = JSON.parse(root.querySelector('[data-mkf-data]').textContent);
    } catch (e) {}
    const keys = data.keys || {};

    const form = root.querySelector('[data-mkf-form]');
    const art = root.querySelector('[data-mkf-art]');
    const plateEl = art && art.querySelector('[data-mkf-plate]');
    const plateField = root.querySelector('[data-mkf-plate-field]');
    const plateInput = root.querySelector('[data-mkf-plate-input]');
    const colorNote = root.querySelector('[data-mkf-color-note]');
    const addBtn = root.querySelector('[data-mkf-add]');
    const errorEl = root.querySelector('[data-mkf-error]');
    const group = (name) => (form ? Array.from(form.querySelectorAll(`input[type="radio"][name^="${name}"]`)) : []);
    const tiers = group('mkf-tier');
    const colors = group('mkf-color');
    const mats = group('mkf-mat');
    const sides = group('mkf-side');
    const picked = (list) => list.find((r) => r.checked) || list[0];

    let shots = {};
    try {
      shots = JSON.parse(root.querySelector('[data-mkf-shots]').textContent);
    } catch (e) {}
    const shotImg = art && art.querySelector('.mkf-shot__img:not(.mkf-shot__img--fallback)');
    if (shotImg) shotImg.dataset.key = `${art.dataset.tier}-${art.dataset.color}-${art.dataset.mat}`;
    const preloaded = {};
    const preload = () => {
      if (!shotImg) return;
      Object.keys(shots).forEach((k) => {
        if (preloaded[k]) return;
        const im = new Image();
        im.sizes = shotImg.getAttribute('sizes') || '';
        im.srcset = shots[k].srcset;
        im.src = shots[k].src;
        preloaded[k] = im;
      });
    };
    const showShot = (key) => {
      const sh = shots[key];
      if (!shotImg || !sh || shotImg.dataset.key === key) return;
      shotImg.dataset.key = key;
      art.classList.add('is-swapping');
      const done = () => art.classList.remove('is-swapping');
      shotImg.addEventListener('load', done, { once: true });
      shotImg.addEventListener('error', done, { once: true });
      shotImg.srcset = sh.srcset;
      shotImg.src = sh.src;
      if (shotImg.complete) done();
    };

    const say = (msg) => {
      if (!errorEl) return;
      errorEl.textContent = msg || '';
      errorEl.hidden = !msg;
    };

    const sync = () => {
      const t = picked(tiers);
      if (!t) return;
      const canColor = t.dataset.colors === 'true';
      const canPlate = t.dataset.plaque === 'true';
      colors.forEach((c) => {
        c.disabled = !canColor && c.value !== 'black';
      });
      if (!canColor) {
        const black = colors.find((c) => c.value === 'black');
        if (black) black.checked = true;
      }
      if (colorNote) colorNote.hidden = canColor;
      if (plateField) plateField.hidden = !canPlate;
      const c = picked(colors);
      const m = picked(mats);
      if (art) {
        art.dataset.tier = t.value;
        if (c) art.dataset.color = c.value;
        if (m) art.dataset.mat = m.value;
        showShot(`${t.value}-${c ? c.value : 'black'}-${m ? m.value : 'cream'}`);
      }
      if (plateEl) {
        const txt = plateInput && plateInput.value.trim();
        plateEl.textContent = txt || data.plateDefault || '';
        fitPlate(plateEl);
      }
      root.querySelectorAll('[data-mkf-add-price], [data-mkf-sticky-price]').forEach((el) => {
        el.textContent = t.dataset.price || el.textContent;
      });
      root.querySelectorAll('[data-mkf-sticky-name]').forEach((el) => {
        el.textContent = t.dataset.name || '';
      });
      if (addBtn) addBtn.disabled = !t.dataset.variant;
    };

    const params = new URLSearchParams(window.location.search);
    const want = (params.get('lijst') || '').toLowerCase();
    if (want) {
      const r = tiers.find((x) => x.value === want);
      if (r) r.checked = true;
    }
    if (form) {
      form.addEventListener('change', () => {
        sync();
        say('');
      });
    }
    if (plateInput) plateInput.addEventListener('input', sync);
    sync();

    // Warm the cache for the other frames once the visitor reaches the configurator
    if (form) {
      form.addEventListener('pointerover', preload, { once: true });
      form.addEventListener('focusin', preload, { once: true });
    }
    if (art && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          preload();
          io.disconnect();
        }
      }, { rootMargin: '300px 0px' });
      io.observe(art);
    }

    // Order
    if (addBtn) {
      addBtn.addEventListener('click', () => {
        const t = picked(tiers);
        const id = t && parseInt(t.dataset.variant, 10);
        if (!id || addBtn.getAttribute('aria-busy') === 'true') return;
        const props = {};
        const c = picked(colors);
        const m = picked(mats);
        const sd = picked(sides);
        if (keys.color && c) props[keys.color] = c.dataset.label || c.value;
        if (keys.mat && m) props[keys.mat] = m.dataset.label || m.value;
        if (keys.side && sd) props[keys.side] = sd.dataset.label || sd.value;
        const plate = plateInput && plateInput.value.trim();
        if (keys.plate && t.dataset.plaque === 'true' && plate) props[keys.plate] = plate;
        addBtn.setAttribute('aria-busy', 'true');
        addBtn.disabled = true;
        say('');
        fetch(`${shopRoot}cart/add.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id, quantity: 1, properties: props }] }),
        })
          .then((res) => {
            if (res.ok) {
              window.location.href = `${shopRoot}cart`;
              return;
            }
            addBtn.removeAttribute('aria-busy');
            addBtn.disabled = false;
            say(res.status === 422 ? data.msgFull : data.msgError);
          })
          .catch(() => {
            addBtn.removeAttribute('aria-busy');
            addBtn.disabled = false;
            say(data.msgError);
          });
      });
    }

    // Smooth jumps
    root.querySelectorAll('a[data-mkf-go]').forEach((link) => {
      link.addEventListener('click', (event) => {
        const id = (link.getAttribute('href') || '').replace('#', '');
        const target = id && root.querySelector(`#${id}`);
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      });
    });

    // Sticky bar
    const bar = root.querySelector('[data-mkf-sticky]');
    const hero = root.querySelector('.mkf-hero');
    const build = root.querySelector('#samenstellen');
    const close = root.querySelector('.mkf-close');
    if (!bar || !hero || !('IntersectionObserver' in window)) return;
    let pastHero = false;
    let buildVisible = false;
    let closeVisible = false;
    const show = () => {
      bar.hidden = !(pastHero && !buildVisible && !closeVisible);
    };
    new IntersectionObserver(([entry]) => {
      pastHero = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      show();
    }).observe(hero);
    if (build) {
      new IntersectionObserver(([entry]) => {
        buildVisible = entry.isIntersecting;
        show();
      }, { rootMargin: '0px 0px -25% 0px' }).observe(build);
    }
    if (close) {
      new IntersectionObserver(([entry]) => {
        closeVisible = entry.isIntersecting;
        show();
      }).observe(close);
    }
  });
})();
